module.exports = __webpack_public_path__ + "static/features-performance-audit-e6c16db2f09808327351933b250669f7.jpg";